var exports = {
  "kL": "x31de4314--b2d602--container",
  "Nr": "x31de4314--b2d602--card",
  "dS": "x31de4314--b2d602--colored",
  "$_": "x31de4314--b2d602--media",
  "U": "x31de4314--b2d602--wide",
  "Qs": "x31de4314--b2d602--content",
  "ju": "x31de4314--b2d602--general",
  "HU": "x31de4314--b2d602--aside",
  "dq": "x31de4314--b2d602--agent-cont",
  "MA": "x31de4314--b2d602--agent",
  "vD": "x31de4314--b2d602--vas",
  "nf": "x31de4314--b2d602--link",
  "nK": "x31de4314--b2d602--comments",
  "Uo": "x31de4314--b2d602--buttons",
};

module.exports = exports;
